import React from "react";
import { BsTwitter, BsLinkedin } from "react-icons/bs";
//import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://twitter.com/shu_bham_knows">
        <BsTwitter />
      </a>
    </div>
    <div>
      <a href="https://www.linkedin.com/in/shubham-verma-873b53127/">
        <BsLinkedin />
      </a>
    </div>
  </div>
);

export default SocialMedia;
